/**
 * Veeroute.Lastmile
 * Veeroute Lastmile API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The level of the intermediate solution detail to be returned:   * `FULL` - full response.   * `STATISTICS` - only the calculation and statistics progress, without trips.   * `PROGRESS` - only the current calculation progress and calculation information. If the calculation is not completed, only the current progress is returned by default. If the calculation is completed, this parameter is ignored and the full response is returned. 
 */
export enum CalculationDetailLastmile {
    FULL = 'FULL',
    STATISTICS = 'STATISTICS',
    PROGRESS = 'PROGRESS'
};

